import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {AiFeatureCategory} from 'nutshell-graphql-types';
import type {
    GetAiFeatureUsage as GetAiFeatureUsageQuery,
    GetAiFeatureUsageVariables as GetAiFeatureUsageQueryVariables,
    GetAiFeatureUsage_aiFeatureUsage as AiFeatureUsage,
} from 'nutshell-graphql-types';

import GET_AI_FEATURE_USAGE from '../queries/get-ai-feature-usage.graphql';

export const useGetAiFeatureUsage = (
    category: AiFeatureCategory
): {
    aiFeatureUsage: AiFeatureUsage | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {data, loading, error, refetch} = useQuery<
        GetAiFeatureUsageQuery,
        GetAiFeatureUsageQueryVariables
    >(GET_AI_FEATURE_USAGE, {
        variables: {category},
    });

    return {
        aiFeatureUsage: data?.aiFeatureUsage ?? null,
        isLoading: loading && !data,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
